export default __webpack_public_path__ + "static/media/right-arrow-long-icon.617932c6.svg";